import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  CmsFormField,
  DirectDebitFormField,
} from '@domgen/dgx-fe-business-models';
import {
  ControlType,
  CustomValidatorService,
  FieldDef,
  SelectDef,
  SortCodeDef,
  TextInputDef,
} from '@domgen/dgx-fe-dynamic-form-builder';
import * as CmsHelpers from '../../cms-form-helper/cms-form-helpers';

@Injectable({
  providedIn: 'root',
})
export class DirectDebitFormConfigService {
  defaultPaymentDay = '1';
  constructor(private customValidatorService: CustomValidatorService) {}

  public getFormbuilderConfig(cmsFormData: CmsFormField[]): FieldDef[] {
    return [
      this.getInputDefByFieldName(
        cmsFormData,
        DirectDebitFormField.AccountName
      ),
      this.getInputDefByFieldName(
        cmsFormData,
        DirectDebitFormField.AccountNumber
      ),
      this.getInputDefByFieldName(cmsFormData, DirectDebitFormField.SortCode),
      this.getInputDefByFieldName(
        cmsFormData,
        DirectDebitFormField.MonthlyPaymentDay
      ),
    ] as FieldDef[];
  }

  private getInputDefByFieldName(
    cmsFormData: CmsFormField[],
    formField: DirectDebitFormField
  ): FieldDef {
    let fieldDef: FieldDef;
    const cmsFormField = CmsHelpers.getFormField<CmsFormField>(
      cmsFormData,
      formField
    );
    const defaultFieldDef = CmsHelpers.getDefaultFieldDef(
      cmsFormField,
      formField
    );

    switch (formField) {
      case DirectDebitFormField.AccountName:
        fieldDef = {
          ...defaultFieldDef,
          controlType: ControlType.INPUT,
          validators: [Validators.required],
        } as TextInputDef;
        break;
      case DirectDebitFormField.AccountNumber:
        fieldDef = {
          ...defaultFieldDef,
          controlType: ControlType.INPUT,
          maxlength: 8,
          validators: [
            Validators.required,
            this.customValidatorService.directDebitAccountNumberValidator,
          ],
        } as TextInputDef;
        break;
      case DirectDebitFormField.SortCode:
        fieldDef = {
          ...defaultFieldDef,
          controlType: ControlType.SORTCODE,
          validators: [
            Validators.required,
            Validators.minLength(6),
            this.customValidatorService.directDebitSortCodeValidator,
          ],
        } as SortCodeDef;
        break;
      case DirectDebitFormField.MonthlyPaymentDay:
        fieldDef = {
          ...defaultFieldDef,
          controlType: ControlType.SELECT,
          validators: [Validators.required],
          options: this.dayOfMonth(),
          initialValue: this.defaultPaymentDay,
          fitContent: true,
        } as SelectDef;
        break;
      default:
        fieldDef = {
          ...defaultFieldDef,
        } as FieldDef;
        break;
    }

    return fieldDef;
  }

  private dayOfMonth(maxDay: number = 28): string[] {
    const days = [];
    for (let i = 1; i <= maxDay; i++) {
      days.push(`${i}`);
    }

    return days;
  }
}
